<div class="summary__media  text-center">
    <p class="text-uppercase p-small">
        <strong [innerHTML]="dateFormatted | date : 'EEE'"></strong>
    </p>
    <strong class="h2" [innerHTML]="dateFormatted | date : 'dd'"></strong>
    <p class="text-uppercase p-small" [innerHTML]="dateFormatted | date : 'MMMM'"></p>
    <p class="p-small" [innerHTML]="dateFormatted | date : DateFormatTime" [hidden]="!includeTime"></p>
</div>